// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZrGp5RvckWlap92EGhGz{width:500px}.ZrGp5RvckWlap92EGhGz .chatbot{position:relative !important}`, "",{"version":3,"sources":["webpack://./src/components/Chatbot/chatbot.module.scss"],"names":[],"mappings":"AAAA,sBACI,WAAA,CAGI,+BACI,4BAAA","sourcesContent":[".container {\n    width: 500px;\n\n    :global {\n        .chatbot {\n            position: relative !important;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ZrGp5RvckWlap92EGhGz`
};
export default ___CSS_LOADER_EXPORT___;
